export const GATEWAY_DISPLAY_NAME_MAX_LENGTH = 10

export function truncateGatewayDisplayName(name: string): string {
  if (name.length <= GATEWAY_DISPLAY_NAME_MAX_LENGTH) {
    return name
  }

  return `${name.slice(0, GATEWAY_DISPLAY_NAME_MAX_LENGTH)}...`
}
